import { Pipe, PipeTransform } from '@angular/core';
import { labels } from '../constants/labels.constants';
import { CommonService } from '../services/common.service';

@Pipe({
  name: 'translator',
  standalone: true,
})
export class TranslatorPipe implements PipeTransform {
  constructor(public comSvc: CommonService) {}
  lang: string = this.comSvc.getNavigatorLang();
  transform(value: any): any {
    return labels[value][this.lang];
  }
}
